var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isBlocked(_vm.propUser.id))?_c('a',{on:{"click":_vm.unblock}},[_vm._v(" 解除 ")]):_c('a',{on:{"click":_vm.block}},[_vm._v(" ブロック ")])}
var staticRenderFns = []

export { render, staticRenderFns }